import { db } from "../firebase";
import { collection, query, orderBy, getDocs, where } from "firebase/firestore";

export const getSuppliersRecords = async (str) => {
  try {
    const suppliersRef = collection(db, "suppliers");
    const q = query(
      suppliersRef,
      where("A153_カナ.value", ">=", str),
      where("A153_カナ.value", "<=", str + "\uf8ff"),
      orderBy("A153_カナ.value"),
      orderBy("A153_gasicd.value")
    );
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};

export const getSuppliersRecordsByNumber = async (number) => {
  const padNum = String(number).padStart(5, "0");
  try {
    const suppliersRef = collection(db, "suppliers");
    const q = query(
      suppliersRef,
      where("A153_gasicd.value", "==", padNum),
      orderBy("A153_gasicd.value")
    );
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};
